import React from 'react';
import styles from './AddresseeItem.module.scss';
import { Form } from 'antd';
import DispexInput, { typeInput } from '../../../../components/DispexInput';
import { ReactComponent as DeleteIcon } from '../../../../resource/DeleteIcon.svg';

const AddresseeItem = ({ form, index, allowDelete, deleteItem }) => {
  const { getFieldDecorator } = form;

  return (
    <div className={styles.root}>
      <Form.Item
        label="Адресат"
        className={styles.item}
      >
        {getFieldDecorator(`custNames[${index}]`, {
          rules: [
            {
              message: 'Пожалуйста введите ФИО собственника',
            },
            {
              message:
                'Пожалуйста, укажите ФИО без запятых. Чтобы добавить еще одного адресата, нажмите кнопку выше.',
              validator: (_rule, value, callback) =>
                !value || !value.includes(','),
            },
            {
              max: 150,
              message: 'Длина поля ФИО не должна превышать 150 символов.',
            },
          ],
        })(
          <DispexInput
            placeholder="ФИО"
            typeInput={typeInput.input}
            className={styles.inputCustom}
          />
        )}
      </Form.Item>
      {allowDelete && (
        <DeleteIcon
          style={{ cursor: 'pointer', fill: '#F93336', marginBottom: 10 }}
          onClick={() => deleteItem(index)}
        />
      )}
    </div>
  );
};

export default AddresseeItem;
